module.exports = __webpack_public_path__ + "static/media/not-verified.2b5499fe.svg";